import {stage} from '../stage';

// FNP-684 (FNP-676 S1b): flexinet-stripe-api relocated marketplace OU -> billing OU
// (FNP-681). Repointed these endpoints at the billing-account stripe-api per stage.
// This is an ENDPOINT-only repoint: Cognito is centralized, so the frontend keeps
// authenticating against the SAME user pool the relocated API trusts (dev INBgfMat1 /
// test UuiFFepVO / prod bxdNeqDGn — verified against each relocated API's userPoolConfig).
// No auth.ts change and no atomic-swap risk (the pool never changed). The old marketplace
// stripe-api endpoints (p52e2ywr / hoyf5aar / acyaqdzi) were torn down with FNP-681.
const stripeAPI = {
    prod: {
        endpoint: 'https://4wycz6ww5bdvzcgoveofutmi2i.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://wcjf73kfrfhlho6rac6jyddevu.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://6fcd6utez5cvxdyztg7zmddz6i.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://6fcd6utez5cvxdyztg7zmddz6i.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

export const appSyncConfig = stripeAPI[stage];

